import { TAdFoxBannerCompleteSizes } from '@cian/adfox-component';
import { MortgageAnnotations, Ticker } from '@cian/adfox-templates';
import { Label, Image, UIHeading3, UIText1 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './TgbNativedescGeneralNarrow.css';

export type TTgbNativedescGeneralProps = {
  url: string;
  image: string;
  logoUrl: string | undefined;
  title: string;
  annotation: string;
  label: string | undefined;
  description: string | undefined;
  sizes: TAdFoxBannerCompleteSizes;
  mortgageTermsWarning: string | undefined;
  mortgageWarning: string | undefined;
};

export const TgbNativedescGeneralNarrow: React.FC<TTgbNativedescGeneralProps> = ({
  title,
  annotation,
  image,
  url,
  label,
  logoUrl,
  description,
  sizes,
  mortgageTermsWarning,
  mortgageWarning,
}) => {
  const withMortgageAnnotations = !!(mortgageWarning || mortgageTermsWarning);

  return (
    <a
      data-testid="url"
      href={url}
      target="_blank"
      className={cn(styles['container'], withMortgageAnnotations && styles['container-with-mortgage-annotations'])}
      rel="noopener noreferrer"
      style={sizes}
    >
      <div className={styles['content']}>
        <div className={styles['title-container']}>
          <UIHeading3 data-testid="title">{title}</UIHeading3>
          {!!description && <UIText1 data-testid="description">{description}</UIText1>}
        </div>
        {!!logoUrl && (
          <div className={styles['logo-container']}>
            <Image data-testid="logoUrl" src={logoUrl} borderRadius="4px" width={60} height={60} objectFit="contain" />
          </div>
        )}
      </div>
      {withMortgageAnnotations && (
        <div className={styles['mortgage-annotations']}>
          <MortgageAnnotations
            splitMortgageTermsWarning
            height={sizes.height}
            mortgageTermsWarning={mortgageTermsWarning}
            mortgageWarning={mortgageWarning}
          />
        </div>
      )}
      <div data-testid="image" className={styles['photo-block']} style={{ backgroundImage: `url(${image})` }}>
        {!!label && (
          <div className={styles['photo-label']}>
            <Label data-testid="label" color="text-inverted-default" background="text-secondary-default">
              {label}
            </Label>
          </div>
        )}
        {!!annotation && (
          <div data-testid="annotation" className={styles['annotation']}>
            <Ticker withBackground text={annotation} />
          </div>
        )}
      </div>
    </a>
  );
};
